import { PlusCircleIcon } from '@heroicons/react/24/outline'
import React from 'react'
import useModel from './model'
import clsx from 'clsx'
import NodeNew from './new'

const NodeAdd = () => {
  const model = useModel()
  return (
    <div className="py-3">
      {model.adding ? (
        <NodeNew model={model} />
      ) : (
        <button
          onClick={() => (model.adding = !model.adding)}
          className={clsx(model.adding && 'opacity-50', 'mt-4')}
        >
          <PlusCircleIcon className="w-6 h-6" />
        </button>
      )}
    </div>
  )
}

export default NodeAdd
